import React, { useEffect, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import PropTypes from 'prop-types';
import ModalLayout from '../ModalLayout';
import ModalBodyLayout from '../ModalBodyLayout';
import { GenericLoading } from '../../../components/Placeholders';

const Recaptcha = ({ onChange, token, resetToken, isLoading }) => {
  const recaptchaRef = useRef(null);

  useEffect(() => {
    const refreshCaptcha = () => {
      if (recaptchaRef.current && token) {
        recaptchaRef.current.reset();
        resetToken('');
      }
    };

    let tokenRefreshTimeout = null;

    if (token) {
      tokenRefreshTimeout = setTimeout(refreshCaptcha, 60000);
    }

    return () => {
      if (tokenRefreshTimeout) {
        clearTimeout(tokenRefreshTimeout);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ModalBodyLayout withBack={false} isButtonInFooter={false} isScrollable={false}>
      <div className="d-flex justify-content-center align-items-center">
        {isLoading && (
          <GenericLoading isFullScreen={false} customSize="4rem" customSpacing="mt-3 mb-1" />
        )}
        {!isLoading && (
          <ReCAPTCHA
            theme="dark"
            sitekey={process.env.REACT_APP_RECAPTCHA_V2}
            onChange={onChange}
          />
        )}
      </div>
    </ModalBodyLayout>
  );
};

Recaptcha.propTypes = {
  onChange: PropTypes.func.isRequired,
  resetToken: PropTypes.func.isRequired,
  token: PropTypes.string,
  isLoading: PropTypes.bool,
};

Recaptcha.defaultProps = {
  token: null,
  isLoading: false,
};

const RecaptchaModal = ({
  isModalVisible,
  onChange,
  token,
  resetToken,
  isLoading,
  setIsModalVisible,
}) => (
  <ModalLayout
    modalContentStyle={{ height: 'fit-content' }}
    onHide={() => setIsModalVisible(false)}
    withButtons={false}
    isVisible={isModalVisible}
    currentScreen="recaptcha">
    <Recaptcha
      keyName="recaptcha"
      onChange={onChange}
      resetToken={resetToken}
      token={token}
      isLoading={isLoading}
    />
  </ModalLayout>
);

export default RecaptchaModal;

RecaptchaModal.propTypes = {
  setIsModalVisible: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  resetToken: PropTypes.func.isRequired,
  token: PropTypes.string,
  isModalVisible: PropTypes.bool,
  isLoading: PropTypes.bool,
};
RecaptchaModal.defaultProps = {
  isModalVisible: false,
  isLoading: false,
  token: null,
};
